import { render, staticRenderFns } from "./FormControlUsersAdministrator.vue?vue&type=template&id=fadfd4f8"
import script from "./FormControlUsersAdministrator.vue?vue&type=script&setup=true&lang=js"
export * from "./FormControlUsersAdministrator.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports